export const POST_PAY_CLIENT = 1;
export const POST_PAY_KODDI = 2;
export const POST_PAY_AUTO = 3;
